export default {
  locale: state => state.locale,
};



// WEBPACK FOOTER //
// ./src/store/modules/i18n/getters.js